module.exports = __webpack_public_path__ + "img/train-6.2b3cb766.jpg";